"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = require("react");

var lazy_1 = __importDefault(require("react-player/lazy"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var react_2 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var VideoUrls;

(function (VideoUrls) {
  VideoUrls["YouTube"] = "https://www.youtube.com/embed/";
  VideoUrls["Vimeo"] = "https://vimeo.com/";
})(VideoUrls || (VideoUrls = {}));

var IconHeight;

(function (IconHeight) {
  IconHeight[IconHeight["sm"] = 15] = "sm";
  IconHeight[IconHeight["md"] = 24] = "md";
  IconHeight[IconHeight["lg"] = 25] = "lg";
})(IconHeight || (IconHeight = {}));

var SvgOffset;

(function (SvgOffset) {
  SvgOffset[SvgOffset["sm"] = 6] = "sm";
  SvgOffset[SvgOffset["md"] = 8] = "md";
  SvgOffset[SvgOffset["lg"] = 10] = "lg";
})(SvgOffset || (SvgOffset = {}));

var VideoWrapper = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n"])));
var VideoContainer = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n"])));

var getPosition = function getPosition(orientation, buttonSize, isMobile, width) {
  switch (orientation) {
    case "right":
      if (isMobile) {
        return (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\t\tleft: calc(100% + ", " / 2 * -1);\n\t\t\t\t"])), width);
      } else {
        return (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t\t\tleft: calc(100% + ", " / 2 * -1);\n\t\t\t\t"])), width);
      }

    case "top":
      return (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\t\ttop: calc(", " / 2 * -1);\n\t\t\t"])), width);

    case "bottom":
      return (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\t\ttop: calc(100% + ", " / 2 * -1);\n\t\t\t"])), width);

    case "top-right":
      if (isMobile) {
        return (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\t\t\ttop: calc(", " / 2 * -1);\n\t\t\t\t\tright: 6%;\n\t\t\t\t"])), width);
      } else {
        return (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\t\ttop: calc(", " / 2 * -1);\n\t\t\t\t\tright: 6%;\n\t\t\t\t"])), width);
      }

    case "left":
    default:
      if (isMobile) {
        return (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\tleft: calc(", " / 2 * -1);\n\t\t\t\t"])), width);
      } else {
        return (0, react_2.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\t\t\tleft: calc(", " / 2 * -1);\n\t\t\t\t"])), width);
      }

  }
};

var PlayButton = styled_1.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\tborder-radius: 250px;\n\talign-self: center;\n\n\t", "\n\n\tspan {\n\t\tposition: absolute;\n\t}\n"])), function (props) {
  var theme = props.theme,
      type = props.type,
      buttonOrientation = props.buttonOrientation,
      buttonSize = props.buttonSize;
  var _theme$colors$primary = theme.colors.primary,
      primaryBrand = _theme$colors$primary.primaryBrand,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      accentBrand = _theme$colors$primary.accentBrand;
  var btnSizeMobile = buttonSize === "lg" ? "100px" : buttonSize === "md" ? "80px" : "60px";
  var btnSizeDesktop = buttonSize === "lg" ? "140px" : buttonSize === "md" ? "120px" : "80px";
  var iconHeight = IconHeight[buttonSize];
  var svgOffset = SvgOffset[buttonSize];
  return (0, react_2.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t\tposition: absolute;\n\t\t\theight: ", ";\n\t\t\twidth: ", ";\n\n\t\t\t@media only screen and (max-width: ", ") {\n\t\t\t\theight: ", ";\n\t\t\t\twidth: ", ";\n\n\t\t\t\tspan {\n\t\t\t\t\tleft: calc(calc(100% / 2) - ", "px);\n\t\t\t\t\ttop: calc(100% / 2 - ", "px);\n\t\t\t\t}\n\t\t\t\t", "\n\t\t\t}\n\t\t\t@media only screen and (min-width: ", ") {\n\t\t\t\tspan {\n\t\t\t\t\tleft: calc(calc(100% / 2) - ", "px);\n\t\t\t\t\ttop: calc(100% / 2 - ", "px);\n\t\t\t\t}\n\t\t\t\t", "\n\t\t\t}\n\t\t"])), type === "primary" ? primaryBrand : type === "secondary" ? secondaryBrand : accentBrand, btnSizeDesktop, btnSizeDesktop, theme.breakpoints.lg, btnSizeMobile, btnSizeMobile, svgOffset, Number(iconHeight) / 2, buttonOrientation !== "center" && getPosition(buttonOrientation, buttonSize, true, btnSizeMobile), theme.breakpoints.lg, svgOffset, Number(iconHeight) / 2, buttonOrientation !== "center" && getPosition(buttonOrientation, buttonSize, false, btnSizeDesktop));
});

var TextWrapper = function TextWrapper(breakPoint) {
  return (0, react_2.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tbottom: 40px;\n\tleft: 40px;\n\twhite-space: pre-wrap;\n\tline-height: 25px;\n\n\t@media only screen and (max-width: ", ") {\n\t\tbottom: 15px;\n\t\tleft: 15px;\n\t}\n"])), breakPoint);
};

var Video = function Video(_ref) {
  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$videoType = _ref.videoType,
      videoType = _ref$videoType === void 0 ? "YouTube" : _ref$videoType,
      videoId = _ref.videoId,
      _ref$buttonOrientatio = _ref.buttonOrientation,
      buttonOrientation = _ref$buttonOrientatio === void 0 ? "left" : _ref$buttonOrientatio,
      _ref$controls = _ref.controls,
      controls = _ref$controls === void 0 ? true : _ref$controls,
      _ref$hidePlayButton = _ref.hidePlayButton,
      hidePlayButton = _ref$hidePlayButton === void 0 ? false : _ref$hidePlayButton,
      _ref$imageUrl = _ref.imageUrl,
      imageUrl = _ref$imageUrl === void 0 ? "" : _ref$imageUrl,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? "" : _ref$text,
      _ref$buttonSize = _ref.buttonSize,
      buttonSize = _ref$buttonSize === void 0 ? "md" : _ref$buttonSize;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var white = theme.colors.primary.white;
  var url = VideoUrls[videoType] + videoId;

  var _ref3 = (0, react_1.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      playing = _ref4[0],
      setPlaying = _ref4[1];

  var _ref5 = (0, react_1.useState)(hidePlayButton ? false : true),
      _ref6 = _slicedToArray(_ref5, 2),
      lightMode = _ref6[0],
      setLightMode = _ref6[1];

  var playVideo = function playVideo() {
    setPlaying(!playing);
    setLightMode(false);
  };

  return (0, jsx_runtime_1.jsx)(VideoContainer, {
    children: (0, jsx_runtime_1.jsx)(VideoWrapper, {
      className: className,
      children: !imageUrl || playing ? (0, jsx_runtime_1.jsx)(lazy_1.default, {
        url: url,
        playing: playing,
        controls: controls,
        width: "100%",
        height: "100%",
        light: lightMode,
        playIcon: hidePlayButton ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) : (0, jsx_runtime_1.jsx)(PlayButton, {
          theme: theme,
          type: type,
          buttonOrientation: buttonOrientation,
          buttonSize: buttonSize,
          onClick: playVideo,
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: "play",
            color: theme.colors.primary.white,
            onClick: playVideo,
            size: buttonSize
          })
        })
      }) : (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        justifyContent: "center",
        style: (0, react_2.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t"]))),
        children: [(0, jsx_runtime_1.jsx)("img", {
          width: "100%",
          height: "100%",
          src: imageUrl
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: TextWrapper(theme.breakpoints.lg),
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "lg",
            color: white,
            children: text
          })
        }), hidePlayButton ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) : (0, jsx_runtime_1.jsx)(PlayButton, {
          theme: theme,
          type: type,
          buttonOrientation: buttonOrientation,
          buttonSize: buttonSize,
          onClick: playVideo,
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: "play",
            color: white,
            onClick: playVideo,
            size: buttonSize
          })
        })]
      })
    })
  });
};

exports.Video = Video;